import { render, staticRenderFns } from "./qtxx.vue?vue&type=template&id=18d3194e&scoped=true"
import script from "./qtxx.vue?vue&type=script&lang=js"
export * from "./qtxx.vue?vue&type=script&lang=js"
import style0 from "./qtxx.vue?vue&type=style&index=0&id=18d3194e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d3194e",
  null
  
)

export default component.exports